<script setup lang="ts">
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { useVoucherAssigneeOptions } from '@/composables/useVoucherAssigneeOptions';
    import { splitAssigneeIds } from '@/utils/voucherAssignees';
    import { watch } from 'vue';

    const props = defineProps<{
        form: any;
        companyId: number;
    }>();

    const { assigneeOptions, isLoadingAssigneeOptions, dedupeAssigneeIds } =
        useVoucherAssigneeOptions(props.companyId);

    watch(
        () => props.form.assignee_ids,
        (assigneeIds) => {
            const deduped = dedupeAssigneeIds(assigneeIds ?? []);

            if (JSON.stringify(deduped) !== JSON.stringify(assigneeIds ?? [])) {
                props.form.assignee_ids = deduped;

                return;
            }

            const { employee_ids, user_ids } = splitAssigneeIds(deduped);
            props.form.employee_ids = employee_ids;
            props.form.user_ids = user_ids;
        },
        { deep: true },
    );
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="assignee_ids"
            label="vouchers.select.assign_confirm.assigned"
        >
            <MultiCombobox
                v-model="form.assignee_ids"
                :options="assigneeOptions"
                label-by="label"
                value-by="id"
                :show-remove-button="false"
                :loading="isLoadingAssigneeOptions"
            />
        </InputRow>
    </div>
</template>
